import { NavLink, Outlet } from 'react-router-dom';
import { Globe, Key, Lock, Mail, Server, Tag, User } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/settings/keys', icon: Key, label: 'Clés API' },
  { to: '/settings/vms', icon: Server, label: 'VMs' },
  { to: '/settings/secrets', icon: Lock, label: 'Secrets services' },
  { to: '/settings/domains', icon: Globe, label: 'Domaines' },
  { to: '/settings/email-accounts', icon: Mail, label: 'Comptes Email' },
  { to: '/settings/label-mappings', icon: Tag, label: 'Label mappings' },
  { to: '/settings/account', icon: User, label: 'Compte' },
];

export default function SettingsLayout() {
  return (
    <div>
      <PageHeader title="Paramètres" description="Configuration du Dispatcher" />
      <div className="flex items-center gap-1 border-b border-brand-border mb-6">
        {TABS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors',
                isActive
                  ? 'text-brand-primary border-brand-primary'
                  : 'text-gray-500 border-transparent hover:text-brand-dark',
              )
            }
          >
            <Icon size={14} />
            {label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
